import {
  Box,
  Avatar,
  Badge,
  Text,
  Flex,
  Image,
  Select,
  useDisclosure,
  Divider,
} from "@chakra-ui/react";
import DepartmentFrame from "../../../../assets/images/DepartementLink.svg";
import BranchFrame from "../../../../assets/images/BranchFrame.svg";
import EmailFrame from "../../../../assets/images/EmailFrame.svg";
import PhoneFrame from "../../../../assets/images/PhoneFrame.svg";
import GenderFrame from "../../../../assets/images/GenderFrame.svg";
import CalenderFrame from "../../../../assets/images/CalenderFrame.svg";
import PayrollFrame from "../../../../assets/images/PayrollFrame.svg";
import ShiftFrame from "../../../../assets/images/ShiftFrame.svg";
import BackgroundProfile from "../../../../assets/images/ProfileBackground.jpg";
import ProfilePicture from "../../../../assets/images/AttendanceProfileImg.jpg"
import Arrow from "../../../../assets/images/ArrowHistory.svg";
import CopyIcon from "../../../../assets/images/CopyIcon.svg";
import MyDiv from "./declarationProfile.style";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { useState } from "react";
import { AlertCard } from "../../../../components";
import * as routesNames from '../../../../constants/routes';
import { useNavigate } from "react-router-dom";

const DeclarationProfile = () => {
  const employee = {
    name: "Full Name",
    avatarUrl: ProfilePicture,
    empCode: "#23454GH",
    designation: "Designation",
    status: "Active",
    department: "Engineering",
    branch: "Varanasi",
    email: "employee@email.com",
    phone: "+91 9876543210",
    gender: "Male",
    age: 28,
    dob: "12/03/1996",
    payrollCompany: "Company name",
    usCompany: "Company name",
    shift: "Night Shift",
  };

  const [status, setStatus] = useState(employee.status || "Active");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [pendingStatus, setPendingStatus] = useState<string>("");
  const navigate = useNavigate();
  const handleStatusChange = (newStatus: string) => {
    setPendingStatus(newStatus);
    onOpen();
  };

  const handleConfirmStatusChange = () => {
    if (pendingStatus) {
      setStatus(pendingStatus);
    }
    onClose();
  };

  const handleClick = () =>{
    navigate(routesNames.EMPLOYEEDETAIL)

  }

  const infoItems = [
    { icon: DepartmentFrame, label: "Department", value: employee.department },
    { icon: BranchFrame, label: "Branch", value: employee.branch },
    { icon: EmailFrame, label: "Email", value: employee.email },
    { icon: PhoneFrame, label: "Phone", value: employee.phone },
    { icon: GenderFrame, label: "Gender", value: employee.gender },
    { icon: CalenderFrame, label: "Age / DOB", value: `${employee.age}, (${employee.dob})`, },
    { icon: PayrollFrame, label: "Payroll Company", value: employee.payrollCompany, },
    { icon: PayrollFrame, label: "Company", value: employee.usCompany, },
    { icon: ShiftFrame, label: "Shift", value: employee.shift },
  ];

  return (
    <MyDiv>
      <Box className="profile-container">
        <Box className="scrollable-content">
          <Box className="main">
            <Box position="relative" h="140px" >
              <Image src={BackgroundProfile} alt="Cover" w="100%" h="100%" objectFit="cover" />
            </Box>

            <Flex align="center" gap={4} px={5} mt={-10}>
              <Avatar src={employee.avatarUrl} name={employee.name} size="xl" />
              <Box w="100%" mt={12} >
                <Flex justifyContent="space-between" alignItems="center" width="100%">
                  <Text className="font-poppins text_xl text_medium font_dark">
                    {employee.name}
                  </Text>
                  <Select
                    value={status}
                    onChange={(e) => handleStatusChange(e.target.value)}
                    className="font-poppins text_medium text_xsm"
                    width="78px"
                    height="22px"
                    icon={<ChevronDownIcon ml={2} />}
                    borderRadius="4px"
                    color={status === "Active" ? "#38A169" : "#E53E3E"}
                    sx={{ textAlign: "left", paddingLeft: "4px" }}
                  >
                    <option value="Active" style={{ color: "#38A169" }}>Active</option>
                    <option value="Inactive" style={{ color: "#E53E3E" }}>Inactive</option>
                  </Select>
                </Flex>

                <Flex gap={3} mt={2} alignItems="center" flexWrap="wrap">
                  <Badge className="Badge font-poppins text_medium" fontSize="8px" color="rgba(0, 0, 0, 0.5)" >
                    {employee.empCode}
                    <Image src={CopyIcon} alt="Copy" boxSize="11px" cursor="pointer" />
                  </Badge>
                  <Badge className="designation font-poppins text_sm text_medium" color="rgba(0, 122, 255, 1)">
                    {employee.designation}
                  </Badge>
                </Flex>
              </Box>
            </Flex>

            <Divider orientation='horizontal' mt={6} />

            <Box px={5} mt={6} pb={5}>

              <Text className="font-poppins text_sm text_medium" color="rgba(0, 0, 0, 1)" mb={3} >More Information</Text>

              <Box display="grid" rowGap={4}>
                {infoItems.map((item, idx) => (
                  <Flex key={idx} align="center" gap={3}>
                    <Image src={item.icon} boxSize="24px" alt={item.label} />
                    <Box>
                      <Text className="font-poppins text_medium" fontSize="9px" color="rgba(0, 0, 0, 0.5)">{item.label}</Text>
                      <Text className="font-poppins text_sm text_medium" color="rgba(0, 0, 0, 1)">{item.value}</Text>
                    </Box>
                  </Flex>
                ))}
                <Box mt={2} className="history_btn">
                  <Flex justifyContent="space-between" alignItems="center" cursor="pointer" onClick={handleClick}>
                    <Text className="font-poppins font_dark text_medium text_sm">View Employee Profile</Text>
                    <Image src={Arrow} alt="History"  />
                  </Flex>
                </Box>
              </Box>

            </Box>
          </Box>
        </Box>
      </Box>
      <AlertCard isOpen={isOpen} onClose={onClose} onConfirm={handleConfirmStatusChange} />
    </MyDiv>
  );
};

export default DeclarationProfile;
